const theme = {
  dark: false,
  colors: {
    primary: "rgba(255, 188, 0, 1)",
    background: "rgb(242, 242, 242)",
    card: "rgb(255, 255, 255)",
    text: "rgb(0, 0, 0)",
    notification: "rgba(255, 188, 0, 1)",
  },
};

export default theme;
